import {
    LogLevel,
    Configuration,
} from '@azure/msal-browser';
import { msalConfig } from '../environments/environment';

// Lightweight blank page used ONLY by the hidden iframe that MSAL spins up
// during acquireTokenSilent. Pointing the iframe at the SPA (e.g. /dashboard)
// causes monitor_window_timeout because the full app cannot bootstrap inside
// the iframe fast enough. This page must also be registered as a redirect URI
// on the Entra ID app registration.
export const silentRedirectUri =
    typeof window !== 'undefined'
        ? `${window.location.origin}/msal-redirect.html`
        : '/msal-redirect.html';

export const msal_Config: Configuration = {
    auth: {
        clientId: msalConfig.auth.clientId,
        authority: msalConfig.auth.authority,
        redirectUri: msalConfig.auth.redirectUri,
        postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
        navigateToLoginRequestUrl: msalConfig.auth.navigateToLoginRequestUrl,
    },
    cache: {
        cacheLocation: msalConfig.cache.cacheLocation
    },
    system: {
        // Denotes time interval before token expiry, in which we want to renew the token.
        // Set to 600s (10 min) to ensure ID tokens are refreshed well before they expire,
        // since MSAL's refresh logic primarily targets access tokens.
        tokenRenewalOffsetSeconds: 600,
        // Safety margin above MSAL defaults (6s / 60s) for slow networks.
        iframeHashTimeout: 10000,
        loadFrameTimeout: 10000,
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                console.log(message);
            },
            logLevel: LogLevel.Error,
            piiLoggingEnabled: false,
        },
    },
};

export const loginRequest = {
    scopes: msalConfig.scopes,
};

// Silent-only request template: same scopes, but forces MSAL to use the
// blank redirect page for the hidden iframe instead of the SPA route.
export const silentRequest = {
    scopes: msalConfig.scopes,
    redirectUri: silentRedirectUri,
};
